import '.c7{position:relative;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.g9{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.bh{align-items:flex-start;}.ssr-plugin'
import '.a3{padding:2rem;}.ssr-plugin'
import '.ck{background:var(--palette-white);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.av{position:absolute;}.ssr-plugin'
import '.iv{top:50%;}.ssr-plugin'
import '.iw{right:1rem;}.ssr-plugin'
import '.ix{transform:translateY(-50%);}.ssr-plugin'
import '.iy{width:120px;}.ssr-plugin'
import '.iz{height:120px;}.ssr-plugin'
import '.j0{z-index:0;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.hd{z-index:1;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.j1{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c7 a1 g9 a e b bh a3 ck ai"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="av iv iw ix iy iz j0 a f b"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c7 hd a e bh an j1"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
